module.exports = __webpack_public_path__ + "img/AssistantBMO_SS1.a6c2de8c.png";